import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite';
import { TimelineBody } from './TimelineBody';
import { TimelineContent } from './TimelineContent';
import { TimelineContext } from './TimelineContext';
import { TimelineItem } from './TimelineItem';
import { TimelinePoint } from './TimelinePoint';
import { TimelineTime } from './TimelineTime';
import { TimelineTitle } from './TimelineTitle';
var TimelineComponent = function TimelineComponent(_ref) {
  var children = _ref.children,
    horizontal = _ref.horizontal,
    className = _ref.className;
  var theme = useTheme().theme.timeline;
  return _jsx(TimelineContext.Provider, {
    value: {
      horizontal: horizontal
    },
    children: _jsx("ol", {
      "data-testid": "timeline-component",
      className: classNames(horizontal && theme.direction.horizontal, !horizontal && theme.direction.vertical, className),
      children: children
    })
  });
};
TimelineComponent.displayName = 'Timeline';
TimelineItem.displayName = 'Timeline.Item';
TimelinePoint.displayName = 'Timeline.Point';
TimelineContent.displayName = 'Timeline.Content';
TimelineTime.displayName = 'Timeline.Time';
TimelineTitle.displayName = 'Timeline.Title';
TimelineBody.displayName = 'Timeline.Body';
export var Timeline = Object.assign(TimelineComponent, {
  Item: TimelineItem,
  Point: TimelinePoint,
  Content: TimelineContent,
  Time: TimelineTime,
  Title: TimelineTitle,
  Body: TimelineBody
});